import React, { useCallback, useMemo, useState, useEffect, useRef } from 'react'
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import "./WysiwygInput.scss";
import * as sanitizeHtml from 'sanitize-html';
import showdown from "showdown";
import ListItem from '@tiptap/extension-list-item'
import TextStyle from '@tiptap/extension-text-style'
import { EditorProvider, useCurrentEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { useEditor, EditorContent } from '@tiptap/react';
import Placeholder from '@tiptap/extension-placeholder'


export default function WysiwygInput(props) {

    var converter = new showdown.Converter({ strikethrough: true, simpleLineBreaks: false })

    const isFocus = useRef(false)

    useEffect(() => {
        if (isFocus.current == true) {
            if (props.setFocus) {
                props.setFocus()
            }
        }
    }, [isFocus.current]);

    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                bulletList: {
                    keepMarks: true,
                    keepAttributes: false,
                },
                orderedList: {
                    keepMarks: true,
                    keepAttributes: false,
                },
            }),
            Placeholder.configure({
                placeholder: props?.placeHolder,
            }),
        ],
        autofocus: (props?.autoFocus && !props?.disabled) ? true : false,
        onUpdate: ({ editor }) => {
            props?.changeValue({ target: { name: props.name, value: htmlToMd(editor.getHTML()), id: props.id } });
        },
        onFocus() {
            isFocus.current = true
        },
        onBlur() {
            isFocus.current = false
        }
    });

    function normalizeMd(md) {
        let normalizedMd = md
        
        console.log('---------normalizedMd')
        console.log(normalizedMd)

        normalizedMd = normalizedMd.replaceAll("<!-- -->", "")
        /* normalizedMd = normalizedMd.replaceAll(`
        
        <br>`, "<br>") */
        return normalizedMd
    }
    
    function normalizeHtml(html) {
        let normalizedHtml = html
        normalizedHtml = normalizedHtml.replaceAll("<s>", "<del>")
        normalizedHtml = normalizedHtml.replaceAll("</s>", "</del>")
        normalizedHtml = normalizedHtml.replaceAll("<li><p>", "<li>")
        normalizedHtml = normalizedHtml.replaceAll("</p></li>", "</li>")
        /* normalizedHtml = normalizedHtml.replaceAll("<br>\n\n", "<br>") */
        return normalizedHtml
    }

    function htmlToMd(html) {
        let normalizedHtml = normalizeHtml(html)
        let md = converter.makeMarkdown(normalizedHtml)
        let normalizedMd = normalizeMd(md)
        return normalizedMd
    }

    useEffect(() => {
        if (editor && (props.value && (normalizeMd(props.value) !== htmlToMd(editor.getHTML())))) {
            let htmlFormatted = converter.makeHtml(props.value)
            editor.commands.setContent(htmlFormatted)
        }
    }, [props.value]);

    return (
        <div id="WysiwygInput" className={"border border-gray-400 rounded p-2 position-relative bg-white " + (isFocus.current ? "focus " : "")}>
            {props.disabled && <span className="disabled"></span>}
            <div className="toolbar d-flex flex-wrap">
                <ButtonGroup className="me-2 mb-1">
                    <Button
                        title="Gras"
                        variant={isFocus.current && editor.isActive('bold') ? 'primary' : 'secondary'}
                        onClick={() => editor.chain().focus().toggleBold().run()}
                        disabled={
                            !editor.can()
                                .chain()
                                .focus()
                                .toggleBold()
                                .run()
                        }
                    ><i className="material-icons">format_bold</i></Button>
                    <Button
                        title="Italique"
                        variant={isFocus.current && editor.isActive('italic') ? 'primary' : 'secondary'}
                        onClick={() => editor.chain().focus().toggleItalic().run()}
                        disabled={
                            !editor.can()
                                .chain()
                                .focus()
                                .toggleItalic()
                                .run()
                        }
                    ><i className="material-icons">format_italic</i></Button>
                    <Button
                        title="Barré"
                        variant={isFocus.current && editor.isActive('strike') ? 'primary' : 'secondary'}
                        onClick={() => editor.chain().focus().toggleStrike().run()}
                        disabled={
                            !editor.can()
                                .chain()
                                .focus()
                                .toggleStrike()
                                .run()
                        }
                    ><i className="material-icons">strikethrough_s</i></Button>
                    <Button
                        title="Formater"
                        variant='secondary'
                        onClick={() => editor.chain().focus().unsetAllMarks().run()}
                        disabled={
                            !editor.can()
                                .chain()
                                .focus()
                                .toggleStrike()
                                .run()
                        }
                    ><i className="material-icons">format_clear</i></Button>
                </ButtonGroup>

                <Dropdown className="me-2 mb-1">
                    <Dropdown.Toggle variant={
                        (isFocus.current && (editor.isActive('heading', { level: 1 }) ||
                            editor.isActive('heading', { level: 2 }) ||
                            editor.isActive('heading', { level: 3 }) ||
                            editor.isActive('heading', { level: 4 }) ||
                            editor.isActive('heading', { level: 5 }) ||
                            editor.isActive('heading', { level: 6 }))) ? 'primary' : 'secondary'
                    }>
                        Titre
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item
                            active={editor.isActive('heading', { level: 1 })}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
                        >
                            Titre 1
                        </Dropdown.Item>
                        <Dropdown.Item
                            active={editor.isActive('heading', { level: 2 })}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                        >
                            Titre 2
                        </Dropdown.Item>
                        <Dropdown.Item
                            active={editor.isActive('heading', { level: 3 })}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
                        >
                            Titre 3
                        </Dropdown.Item>
                        <Dropdown.Item
                            active={editor.isActive('heading', { level: 4 })}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
                        >
                            Titre 4
                        </Dropdown.Item>
                        <Dropdown.Item
                            active={editor.isActive('heading', { level: 5 })}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()}
                        >
                            Titre 5
                        </Dropdown.Item>
                        <Dropdown.Item
                            active={editor.isActive('heading', { level: 6 })}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()}
                        >
                            Titre 6
                        </Dropdown.Item>

                    </Dropdown.Menu>
                </Dropdown>

                <ButtonGroup className="me-2 mb-1">
                    <Button
                        title="Liste à puce"
                        variant={isFocus.current && editor.isActive('bulletList') ? 'primary' : 'secondary'}
                        onClick={() => editor.chain().focus().toggleBulletList().run()}
                    ><i className="material-icons">format_list_bulleted</i></Button>
                    <Button
                        title="Liste numérotée"
                        variant={isFocus.current && editor.isActive('orderedList') ? 'primary' : 'secondary'}
                        onClick={() => editor.chain().focus().toggleOrderedList().run()}
                    ><i className="material-icons">format_list_numbered</i></Button>
                </ButtonGroup>

                <Button
                    title="Ligne horizontale"
                    className="me-2 mb-1"
                    variant="secondary"
                    onClick={() => editor.chain().focus().setHorizontalRule().run()}
                ><i className="material-icons">horizontal_rule</i></Button>

                {/* <ButtonGroup className="me-2 mb-1">
                    <Button
                        variant="secondary"
                        onClick={() => editor.chain().focus().undo().run()}
                        disabled={
                            !editor.can()
                                .chain()
                                .focus()
                                .undo()
                                .run()
                        }
                    ><i className="material-icons">undo</i></Button>
                    <Button
                        variant="secondary"
                        onClick={() => editor.chain().focus().redo().run()}
                        disabled={
                            !editor.can()
                                .chain()
                                .focus()
                                .redo()
                                .run()
                        }
                    ><i className="material-icons">redo</i></Button>
                </ButtonGroup> */}

                <Button
                    title="Retour à la ligne"
                    className="me-2 mb-1"
                    variant="secondary"
                    onClick={() => editor.chain().focus().setHardBreak().run()}
                ><i className="material-icons">keyboard_return</i></Button>

            </div>
            <EditorContent editor={editor} />
        </div>
    )
}